import { Utilities } from "../../../utils/utilities";

interface ContractEndDateLabelProps {
  date?: Date;
}

const ONE_MONTH_IN_DAYS = 30;
const SIX_MONTHS_IN_DAYS = 180; // or ONE_MONTH_IN_DAYS * 6

export const ContractEndDateLabel = (props: ContractEndDateLabelProps) => {
  if (props.date) {
    let date = Utilities.formatDate(props.date, "local");
    let color = "black";
    let daysUntilDate = Utilities.daysBetweenDates(new Date(), props.date);

    if (daysUntilDate < ONE_MONTH_IN_DAYS) {
      color = "#cf2424";
    } else if (daysUntilDate < SIX_MONTHS_IN_DAYS) {
      color = "#f5a623";
    }
    return <p style={{ color: color }}>{date}</p>;
  } else {
    return null;
  }
};

